import styled, { css } from 'styled-components';

import type { IStyledKakarikoStickyElementProps } from './types';

export const StyledKakarikoStickyElement = styled.div<IStyledKakarikoStickyElementProps>`
  ${(props: IStyledKakarikoStickyElementProps) => {
    let { $left, $width } = props;

    return css`
      left: ${$left}px;
      position: fixed;
      top: 0;
      width: ${$width}px;
      z-index: 15;
    `;
  }}
`;
